import React, { useState } from 'react';
import { Tabs, Tab } from "react-bootstrap";
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
// import SystemLogsDetails from './SystemLogsDetail';
import PhishingPdfReports from '../../Components/PhishingReportsModal/PhishingReportsPage';
import PhishingPdfList from '../../Components/PhishingPdfList/PhishingPdfList';
const PhishingReports = () => {
    const { id } = useParams(); // Ensure the route contains a parameter named 'id'

    const { t } = useTranslation();
    const [key, setKey] = useState("PhishingPdfReports");
    // State variables



    return (
        <div className="p-4">

            <div className="pageTitle mb-4">{t('PhishingPdfReports')}</div>

            <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => setKey(k)}
                className="mb-3"
            >

                <Tab eventKey="PhishingPdfReports" title={t('PhishingPdfReports')}>
                    <div>
                        <PhishingPdfReports />
                    </div>
                </Tab>
                <Tab eventKey="PhishingPdfList" title={t('PhishingPdfList')}>
                    <div>
                        <PhishingPdfList />
                    </div>
                </Tab>
            </Tabs>

        </div>
    );
};

export default PhishingReports;